import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class GeoLoadModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (GeoLoadModel._instance == null) GeoLoadModel._instance = new GeoLoadModel(authManager);
        return GeoLoadModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/geo-loads');

        this.entityName = 'model-sections.GeoLoad';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Load';
        this.setLabel = 'Loads';

        this.browser = {
            name: 'default-model-sections-geoload-browser',
            moduleName: 'default-model-sections-geoload-browser',
            moduleTitle: 'Loads',
            moduleStateSlotName: 'default-model-sections-geoload-browser',
        };

        this.editor = {
            name: 'default-model-sections-geoload-editor',
            moduleName: 'default-model-sections-geoload-editor',
            moduleTitle: 'Load',
            moduleStateSlotName: 'default-model-sections-geoload-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'elevation',
                type: 'float',
                persistent: true,
                unit: 'masl',
                label: 'Elevation',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'continuousUniformVerticalLoadP',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Continuous Uniform Vertical Load P',
                description: 'at top of interval',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'direction',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Direction',
                description: 'only 180 = vertical downwards',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
